import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  px: 2,
  pt: 1,
};

export const list: SxStyle = {
  px: 2,
  pt: 1,
  height: (p) => p.spacing(12),
};

export const content: SxStyle = {
  background: (p) => p.palette.common.white,
  pb: 1,
};

export const divider: SxStyle = {
  borderColor: (p) => p.palette.primary[100],
  borderStyle: 'dashed',
};

export const text1: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const text2: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};
